<div [ngClass]="{compact: view == BarGraphView.Compact, margin: true}">
  <panel heading="{{panelHeading | translate | async}}">
    <div class="system-overview">
      <!-- <overview-image size="140" src="/Content/Images/{{systemName}}.jpg" [loading]="loadingSystems"></overview-image> -->
      <!-- <overview-image size="140" *ngIf="!FamilyImage_Chain && systemName=='Chain' " src="/Content/Images/chain.jpg"  [loading]="loadingSystems"></overview-image> -->
      <overview-image size="140" *ngIf="systemName=='Chain'" [src]="getImage_(FamilyImage_Chain)" [loading]="loadingSystems"></overview-image>

      <!-- <overview-image size="140" *ngIf="!FamilyImage_Frame && systemName=='Frame' " src="/Content/Images/frame.jpg"  [loading]="loadingSystems"></overview-image> -->
      <overview-image size="140" *ngIf="systemName=='Frame'" [src]="getImage_(FamilyImage_Frame)" [loading]="loadingSystems"></overview-image>

      <div class="system-overview__content">
        <div class="content__primary">
          <item-group>
            <item [label]="'Serial Number' | translate | async" [primary]="true" [loading]="loadingSystems">{{system.SerialNumber}}</item>
          </item-group>
        </div>
        <div class="content__secondary">
          <item-group>
            <item [label]="'Date Installed' | translate | async" [loading]="loadingSystems">{{system.DateInstalled | date:'dd-MMM-yyyy'}}</item>
            <item [label]="'Equipment SMU/Hourmeter at Install' | translate | async" [loading]="loadingSystems">{{system.SmuAtInstall}}</item>
          </item-group>
        </div>
      </div>
    </div>
    <div class="table-container" *ngIf="system.Components.length > 0">
      <div class="component-table-container component-table">
         <!-- <table class="table table--full-width table--striped"> -->
        <table class="table table--full-width component-table">
          <thead>
            <tr>
              <th></th>
              <th>{{'Component' | translate | async}}</th>
              <th>{{'Pos.' | translate | async}}</th>
              <th>{{'Worn' | translate | async}}</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let c of system.Components">
              <!-- <td class="component-cell">
                <div class="component-photo-container">
                  <img class="component-photo" [src]="sanitize(c.ComponentTypeImage)" />
                </div>
              </td> -->

              <td class="component-cell" *ngIf="!c.IsChild">
                <div class="component-photo-container">
                  <img class="component-photo" [src]="sanitize(c.ComponentTypeImage)" />
                </div>
              </td>
              <td *ngIf="c.IsChild" class="line-cell">
                <div class="line-vert{{getChildRowPosition(c.ComponentId)}}"></div>
                <div class="line-hor"></div>
              </td>
              <td>
                <span title="{{c.Name}}" *ngIf="!c.IsChild" class="SerialAndUnitText">{{c.Name | slice:0:30}} {{c.Name.length>30 ? '...' : ''}} </span>
                <span title="{{c.Name}}" *ngIf="c.IsChild" class="SerialAndUnitText">{{c.Name | slice:0:30}} {{c.Name.length>30 ? '...' : ''}}</span>
              </td>
              <!-- <td><span [matTooltip]="c.Name">{{c.Name | slice:0:30}}{{c.Name > 30 ? '...' : ''}}</span></td> -->
              <!-- <td>{{c.Position}}</td> -->
              <td> {{showPosition(c.Pos, c.ComponentTypeId)}}</td>
              <td class="table__eval-cell"><span style="width: 80px;"  [ngClass]="GetEvalColour(c, c.WornPercentage.toFixed(1))">
                  <div style=" text-align: center !important ; display: inline-block;"  *ngIf="c.Tool != 'Eval' ">{{c.WornPercentage}}%</div>
                  <div style=" text-align: center !important ; display: inline-block;"  *ngIf="c.Tool == 'Eval' ">{{c.EvalCode}}</div>
                </span></td>
              <!-- <td class="table__eval-cell"><span style="width: 80px;" class="Eval-{{c.WornPercentage | wornPercentageToEval }}">   <div style=" text-align: center !important ; display: inline-block;">{{c.WornPercentage}}%</div> </span></td> -->
              <td class="inspection-component-photo">
                  <div class="add-recommendation" *ngIf="!c.IsChild && isInterpreter" [class.has-recommendation]="componentHasRecommendation(c.ComponentId)">
                    <i title="Add Recommendation" class="material-icons" (click)="openAddRecommendation(c.ComponentId)">rate_review</i>
                  </div>
                </td>
            </tr>
          </tbody>
        </table>
    </div>
      <div class="hours-table">
        <div matTooltip="Inspection at {{system.InspectionSmu}} SMU/Hourmeter (hrs)" class="inspection-marker" [style.left.px]="inspectionLinePosition"></div>
        <table class="table table--full-width component-table">
          <thead>
            <tr >
              <th *ngFor="let i of getIntervalCount()" [style.width.px]="getIntervalWidth()">{{minimumVisibleSmu + (smuInterval * i)}} {{getIntervalWidth() > 80 ? ('SMU/Hourmeter' | translate | async) : ''}}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let c of system.Components" style="line-height: 45px !important;">
              <td [attr.colspan]="getIntervalCount().length">
                <div class="inline-flex">
                  <div class="hours-done" [style.width.px]="getHoursDoneWidthPixels(c.ComponentId)" [style.left.px]="getHoursDoneLeftPixels(c.ComponentId)">
                    <span class="hours-done__text">
                      <i class="material-icons info-small" [matTooltip]="c.Cmu + ' hrs (hours on surface)'" *ngIf="getHoursDoneWidthPixels(c.ComponentId) > 49">info</i><span *ngIf="getHoursDoneWidthPixels(c.ComponentId) > 70">{{c.Cmu}} hrs</span>
                    </span>
                  </div>
                  <div class="hours-remaining" [style.width.px]="getHoursRemaining100WidthPixels(c.ComponentId)" [style.left.px]="getHoursRemaining100LeftPixels(c.ComponentId)">
                    <span class="hours-remaining__text">
                      <i class="material-icons info-small" [matTooltip]="c.RisidualLife100 + ' hrs (hours remaining until 100% Worn)'" *ngIf="getHoursRemaining100WidthPixels(c.ComponentId) > 49">info</i><span *ngIf="getHoursRemaining100WidthPixels(c.ComponentId) > 70">{{c.RisidualLife100}} hrs</span>
                    </span>
                  </div>
                  <div class="hours-remaining-120" [style.width.px]="getHoursRemaining120WidthPixels(c.ComponentId)" [style.left.px]="getHoursRemaining120LeftPixels(c.ComponentId)">
                    <span class="hours-remaining-120__text">
                      <i class="material-icons info-small" [matTooltip]="c.RisidualLife120 + ' hrs (hours remaining until 120% Worn)'" *ngIf="getHoursRemaining120WidthPixels(c.ComponentId) > 49">info</i><span *ngIf="getHoursRemaining120WidthPixels(c.ComponentId) > 95">{{c.RisidualLife120}} hrs</span>
                    </span>
                  </div>
                  <div (click)=" isInterpreter ? openEditRecommendation(c.ComponentId, r.RecommendationId) : return" class="recommendation" *ngFor="let r of getComponentRecommendations(c.ComponentId)" [style.width.px]="getRecommendationWidthPixels(c.ComponentId, r.RecommendationId)" [style.left.px]="getRecommendationLeftPixels(c.ComponentId, r.RecommendationId)">
                    <span class="recommendation__text">
                      <i class="material-icons info-small" [matTooltip]="r.RecommendationName + ' at ' + r.StartActionAtSmu + ' SMU and component will gain ' + (r.CompleteActionBySmu - r.StartActionAtSmu) + ' hrs. '">info</i>
                      <span *ngIf="getRecommendationWidthPixels(c.ComponentId, r.RecommendationId) > 210">
                        {{r.RecommendationName}}<b *ngIf="getRecommendationWidthPixels(c.ComponentId, r.RecommendationId) > 290"> +{{r.CompleteActionBySmu - r.StartActionAtSmu}} hrs</b>
                      </span>
                    </span>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </panel>
</div>
